import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["classSelect", "fieldsFrame"]
  static values = { baseUrl: String }

  connect() {
    const classId = this.classSelectTarget.value
    if (classId && this.fieldsFrameTarget.childElementCount === 0) {
      this.loadFields(classId)
    }
  }

  classChanged() {
    const classId = this.classSelectTarget.value
    if (!classId) {
      this.fieldsFrameTarget.innerHTML = ""
      return
    }
    this.loadFields(classId)
  }

  async loadFields(classId) {
    const url = `${this.baseUrlValue}/${classId}/field_inputs`
    const response = await fetch(url, { headers: { Accept: "text/html" } })
    if (!response.ok) return
    const html = await response.text()
    const doc = new DOMParser().parseFromString(html, "text/html")
    const frame = doc.querySelector("turbo-frame#class-fields")
    if (frame) this.fieldsFrameTarget.innerHTML = frame.innerHTML
  }
}
